:host {
  @apply block my-1 py-1 w-fit;
}

a:not(.first) {
  @apply text-[15px] leading-[26px] text-grey transition-all flex items-center gap-2;

  &.active, &:hover {
    @apply text-berry font-bold;
  }
}

a.first {
  @apply text-[18px] leading-[30px] text-grey transition-all flex items-center gap-2 mb-5;

  &.active, &:hover {
    @apply text-berry font-bold;
  }
}
